export default __webpack_public_path__ + "static/media/terms_and_conditions.b09c3b49.pdf";